import { RouteLinks } from '@anyx/shared-utils';

import {
  accountLinks,
  analyticsLinks,
  shippingLinks,
  crmLinks,
  integrationLinks,
  inventoryLinks,
  workflowLinks,
  helperLinks,
  homeLinks,
  orderLinks,
  productLinks,
} from './route-links';
import { WithWorkspaceLinkProps } from './types';

export const getWorkspaceLinks = ({
  workspaceAccountId,
  accountId,
  isCrmEnabled,
  chats,
  channels,
  isAdmin,
  canSeeUserList,
  canUseOrder,
  canUseAnalytics,
  canSeeInventoryStockValue,
  canUseCrm,
  canUseDatasource,
  canUseInventory,
  canUseProduct,
  canUseShipping,
  canUseWorkflow,
  storeId,
  isAllowAdminSectionPage,
}: WithWorkspaceLinkProps): RouteLinks[] => {
  return [
    // Home
    ...homeLinks.withWorkspace({ canUseAnalytics, storeId }),
    // Analytics
    ...analyticsLinks.withWorkspace({
      canUseAnalytics,
      canSeeInventoryStockValue,
      channels,
      storeId,
    }),
    // Order
    ...orderLinks.withWorkspace({ canUseOrder, storeId }),
    // Shipping
    ...shippingLinks.withWorkspace({
      canUseShipping,
      accountId,
      storeId,
    }),
    // Product
    ...productLinks.withWorkspace({ canUseProduct, storeId }),
    // Inventories
    ...inventoryLinks.withWorkspace({ canUseInventory, isAdmin, storeId }),
    // CRM
    ...crmLinks.withWorkspace({
      canUseCrm,
      storeId,
      isCrmEnabled,
      chats,
      isAdmin,
      isAllowAdminSectionPage,
    }),
    // Workflow
    ...workflowLinks.withWorkspace({
      storeId,
      canUseWorkflow,
    }),
    //Integration
    ...integrationLinks.withWorkspace({ canUseDatasource, storeId }),
    // Account
    ...accountLinks.withWorkspace({
      storeId,
      workspaceAccountId,
      canSeeUserList,
    }),
    // Help
    ...helperLinks.withWorkspace(),
  ];
};
